import { ReturnsValue, CSV_VALUES } from '../constants';

export function formatReturns(returnsAccepted: boolean): ReturnsValue {
  return returnsAccepted ? CSV_VALUES.RETURNS_ACCEPTED : CSV_VALUES.RETURNS_NOT_ACCEPTED;
}